import React, { Component } from "react";
import { CircularProgress } from "@mui/material";
import sentryInstance from "../lib/sentryIntegration";

const containerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingTop: "100px",
  flexDirection: "column",
  gap: "20px",
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    sentryInstance.logError(error, errorInfo);

    // Example "componentStack":
    //   in ComponentThatThrows (created by App)
    //   in ErrorBoundary (created by App)
    //   in div (created by App)
    //   in App
    // logErrorToMyService(error, info.componentStack);
  }

  render() {
    console.log("render ErrorBoundary");
    if (this.state.hasError) {
      // You can render any custom fallback UI
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div style={containerStyle}>
          <h2>Please wait!</h2>
          <CircularProgress />
        </div>
      )
    }

    return this.props.children;
  }
}

export default ErrorBoundary;